import {
  faCheckCircle,
  faClock,
  faTachometer,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getActivitiesDashboard } from "../../API/dashboard";
import { secondsToMinutesHours } from "../../Helpers/datetimeHelper";
import PageLoadingContent from "../Reusable/PageLoadingContent";

function Dashboard() {
  const [item, setItems] = useState();
  const [fetching, setFetching] = useState(false);

  const success = (r) => {
    setItems(r);
    setFetching(false);
  };
  const error = (r) => {
    toast.error(r.message);
  };

  const fetch = () => {
    setFetching(true);
    getActivitiesDashboard(success, error);
  };

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
    }
    fetch();
    return () => (mounted = false);
  }, []);

  return (
    <>
      <div class="container">
        <section class="section">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <div class="columns">
              <div class="column">
                <h1 class="title is-4">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </h1>
              </div>
            </div>
          </nav>
          {fetching ? (
            <>
              <PageLoadingContent displayMessage={"Please wait"} />
            </>
          ) : (
            <div class="">
              <section class=" ">
                <div class="grid-3-container m-0 is-3">
                  <div class="column box p-5 pt-6 has-text-centered has-background-primary-light">
                    <p class="title is-5">
                      <FontAwesomeIcon className="fas" icon={faUserGroup} />
                      &nbsp;Total Users
                    </p>
                    <p class="title is-4">{item?.totalOrganizationUsers}</p>
                  </div>
                  <div class="column box p-5 pt-6 has-text-centered has-background-link-light">
                    <p class="title is-5">
                      <FontAwesomeIcon className="fas" icon={faClock} />
                      &nbsp;Total Exercise Time
                    </p>
                    <p class="title is-4">
                      {secondsToMinutesHours(item?.totalTime)}
                    </p>
                  </div>
                  <div class="column box p-5 pt-6 has-text-centered has-background-warning-light">
                    <p class="title is-5">
                      <FontAwesomeIcon className="fas" icon={faCheckCircle} />
                      &nbsp;Total Sessions Completed
                    </p>
                    <p class="title is-4">{item?.totalSessions}</p>
                  </div>
                </div>
              </section>
              <br />
              <section>
                <div className="fixed-grid">
                  <div class="grid-container  m-0 is-3">
                    <div class="column box has-text-centered p-5  is-danger-b ">
                      <div className="is-flex is-2 is-flex-direction-column is-justify-content-space-between is-align-items-center">
                        <img src="assets/excercise.svg" alt="e" />
                        <p class="subtitle is-flex is-flex-direction-row is-justify-content-center is-align-items-center m-0">
                          Rhea exercise
                        </p>
                        <p className="has-text-danger has-text-weight-semibold">
                          {secondsToMinutesHours(item?.exerciseTime)}
                        </p>
                      </div>
                    </div>
                    <div class="column box p-5 has-text-centered is-warning-b">
                      <div className="is-flex is-2 is-flex-direction-column is-justify-content-space-between is-align-items-center">
                        <img src="assets/breath.svg" alt="e" />
                        <p class="subtitle is-flex is-flex-direction-row is-justify-content-center is-align-items-center m-0">
                          Breath work
                        </p>
                        <p className="has-text-warning has-text-weight-semibold">
                          {secondsToMinutesHours(item?.breathworkTime)}
                        </p>
                      </div>
                    </div>
                    <div class="column box  p-5 has-text-centered is-success-b">
                      <div className="is-flex is-2 is-flex-direction-column is-justify-content-space-between is-align-items-center">
                        <img src="assets/movment.svg" alt="e" />
                        <p class="subtitle is-flex is-flex-direction-row is-justify-content-center is-align-items-center m-0">
                          Movement break
                        </p>
                        <p className="has-text-success has-text-weight-semibold">
                          {secondsToMinutesHours(item?.movementTime)}
                        </p>
                      </div>
                    </div>
                    <div class="column box  p-5 has-text-centered is-link-b">
                      <div className="is-flex is-2 is-flex-direction-column is-justify-content-space-between is-align-items-center">
                        <img src="assets/activity.svg" alt="e" />
                        <p class="subtitle is-flex is-flex-direction-row is-justify-content-center is-align-items-center m-0">
                          Activity
                        </p>
                        <p className="has-text-link has-text-weight-semibold">
                          {secondsToMinutesHours(item?.activityTime)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          )}
        </section>
      </div>
    </>
  );
}

export default Dashboard;
